import apiClient from '@/lib/api-client';

export async function getCustomers(tenantId: string, params?: any) {
 const { data } = await apiClient.get(`/tenants/${tenantId}/customers`, { params });
 return data;
}

export async function getCustomerByPhone(tenantId: string, phone: string) {
 const { data } = await apiClient.get(`/tenants/${tenantId}/customers/phone/${phone}`);
 return data.data;
}

export async function createCustomer(tenantId: string, payload: any) {
 const { data } = await apiClient.post(`/tenants/${tenantId}/customers`, payload);
 return data.data;
}

export async function topUpCredit(tenantId: string, customerId: string, payload: any) {
 const { data } = await apiClient.post(`/tenants/${tenantId}/customers/${customerId}/top-up`, payload);
 return data.data;
}